// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","hero":"j_z","hi":"j_B","bounce":"j_C"};